import { getValidAccessToken } from "../services/oauthservice";
import { encryptRSA } from '../services/encrypt.js';

// src/utils/apiLogger.js
export const createApiLog = async (requestData) => {
  try {
    const encrypted = await encryptRSA({ ...requestData });
     const token = await getValidAccessToken();
    const response = await fetch(
      `${process.env.REACT_APP_DIC_ADMIN_API}/v1/logs/api-logs`,
      {
        method: "POST",
        headers: {
             Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ encrypted }) 
      }
    );

    const data = await response.json();
    return data; // return success or error from API
  } catch (error) {
    console.error("Error creating API log:", error);
    return { success: false, message: error.message };
  }
};

export const buyPolicyApi = async (requestData) => {
  try {
    const encrypted = await encryptRSA({ ...requestData });
    const token = await getValidAccessToken();

    const response = await fetch(
      `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/buy-policy`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ encrypted }),
      }
    );

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error buying policy:", error);

    return {
      success: false,
      message: error.message,
    };
  }
};

export const renewPolicyApi = async (requestData) => {
  try {
    const encrypted = await encryptRSA({
      ...requestData,
    });

    const token = await getValidAccessToken();

    const response = await fetch(
      `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/renew-policy`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          encrypted,
        }),
      }
    );

    const data = await response.json();

    return data;
  } catch (error) {
    console.error(
      "Error renewing policy:",
      error
    );

    return {
      success: false,
      message: error.message,
    };
  }
};

export const payPremiumApi = async (requestData) => {
  try {
    const encrypted = await encryptRSA(requestData);
    const token = await getValidAccessToken();

    const response = await fetch(
      `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/pay-premium`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ encrypted }),
      }
    );

    return await response.json();
  } catch (error) {
    console.error("Error paying premium:", error);

    return {
      success: false,
      message: error.message,
    };
  }
};

export const quoteToPolicySuccessApi = async (
  requestData
) => {
  try {
    const encrypted =
      await encryptRSA({
        ...requestData,
      });

    const token =
      await getValidAccessToken();

    const response = await fetch(
      `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/quote-to-policy-success`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type":
            "application/json",
        },
        body: JSON.stringify({
          encrypted,
        }),
      }
    );

    const data =
      await response.json();

    return data;

  } catch (error) {
    console.error(
      "Error processing successful payment:",
      error
    );

    return {
      success: false,
      message: error.message,
    };
  }
};

export const quoteToPolicyFailedApi = async (
  requestData
) => {
  try {
    const encrypted =
      await encryptRSA({
        ...requestData,
      });

    const token =
      await getValidAccessToken();

    const response = await fetch(
      `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/quote-to-policy-failed`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type":
            "application/json",
        },
        body: JSON.stringify({
          encrypted,
        }),
      }
    );

    const data =
      await response.json();

    return data;

  } catch (error) {
    console.error(
      "Error processing failed payment:",
      error
    );

    return {
      success: false,
      message: error.message,
    };
  }
};

export const getPolicyDocumentApi = async (
  requestData
) => {
  try {
    const encrypted =
      await encryptRSA(requestData);

    const token =
      await getValidAccessToken();

    const response = await fetch(
      `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/get-policy-document`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          encrypted
        })
      }
    );

    return await response.json();

  } catch (error) {
    return {
      success: false,
      message: error.message
    };
  }
};

export const motorPayPremiumApi = async (
  requestData
) => {
  try {
    const encrypted =
      await encryptRSA({
        ...requestData,
      });

    const token =
      await getValidAccessToken();

    const response = await fetch(
      `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/motor-pay-premium`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type":
            "application/json",
        },
        body: JSON.stringify({
          encrypted,
        }),
      }
    );

    const data =
      await response.json();

    return data;

  } catch (error) {
    console.error(
      "Error fetching quote details:",
      error
    );

    return {
      success: false,
      message: error.message,
    };
  }
};

export const requestPolicyDocumentMapper =
  async (requestData) => {
    try {
      const encrypted =
        await encryptRSA({
          ...requestData,
        });

      const token =
        await getValidAccessToken();

      const response =
        await fetch(
          `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/policy-document`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type":
                "application/json",
            },
            body: JSON.stringify({
              encrypted,
            }),
          }
        );

      return await response.json();

    } catch (error) {
      console.error(error);

      return {
        success: false,
        message: error.message,
      };
    }
  };

  export const sendOTPApi = async (
  requestData
) => {
  try {
    const encrypted =
      await encryptRSA({
        ...requestData,
      });

    const token =
      await getValidAccessToken();

    const response = await fetch(
      `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/send-otp`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type":
            "application/json",
        },
        body: JSON.stringify({
          encrypted,
        }),
      }
    );

    return await response.json();

  } catch (error) {
    return {
      success: false,
      message: error.message,
    };
  }
};

export const ropResubmissionMapper =
  async (requestData) => {
    try {
      const encrypted =
        await encryptRSA({
          ...requestData,
        });

      const token =
        await getValidAccessToken();

      const response =
        await fetch(
          `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/rop-resubmission`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type":
                "application/json",
            },
            body: JSON.stringify({
              encrypted,
            }),
          }
        );

      return await response.json();

    } catch (error) {
      return {
        success: false,
        message: error.message,
      };
    }
  };